import {
  SMALL_VIEWPORT,
  RECOMMENDED_OUTFITS_HEADER,
  PAGE_AREAS,
} from "../../constants";
import { PrimaryPrice } from "../priceComponents";
import { COMPLEMENTARY_PRIMARY_PRICE } from "../priceComponents/priceTypes";
import ProductCard from "../productCard/ProductCard";
import { useVariant } from "../../context/variant/VariantContext";
import { useViewport } from "../../context/viewport/ViewportContext";
import { getPrimaryVariant } from "../../utils/product";
import PropTypes from "prop-types";
import styles from "./RecommendedOutfitsProduct.scss";
import saveForLater from "../../utils/saveForLater";
import { getFullImageUrl } from "./utils";
import { fireRecommendedOutfitsAddToBagAnalytics } from "../../analytics/addToBag";
import fireNotifyMeClickAnalytics from "../../analytics/backInStock";

export default function RecommendedOutfitsProduct({ product, modalControls }) {
  const { selectedVariant } = useVariant();
  const { viewportCategory } = useViewport();

  if (!product) {
    return null;
  }
  const fullImageUrl = getFullImageUrl(product.images[0].url);

  const defaultColourWayId = getPrimaryVariant(product.variants).colourWayId;
  const variantIdentifier = selectedVariant
    ? `variantId:${selectedVariant.variantId}`
    : `colourWayId:${defaultColourWayId}`;

  const handleSaveClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const identifier = selectedVariant
      ? { variantId: selectedVariant.variantId }
      : { colourWayId: defaultColourWayId };

    saveForLater({
      product,
      items: [{ productId: product.id, ...identifier }],
      pageArea: PAGE_AREAS.RECOMMENDED_OUTFITS,
    });
  };

  const enhanceNotifyMeClickAnalytics = (selectedVariantId) => {
    fireNotifyMeClickAnalytics(
      selectedVariantId,
      PAGE_AREAS.RECOMMENDED_OUTFITS,
      product
    );
  };

  return (
    <div className={styles.container}>
      <ProductCard
        key={product.id}
        product={product}
        productLink={product.pdpUrl || null}
        variantIdentifier={variantIdentifier}
        variantSelectorId="recommendedOutfitsProductVariantSelector"
        imageWidth={viewportCategory === SMALL_VIEWPORT ? 163 : 218}
        primaryImageUrl={fullImageUrl}
        priceRenderProp={() => (
          <PrimaryPrice
            priceData={product.price}
            testId="product-price"
            priceType={COMPLEMENTARY_PRIMARY_PRICE}
          />
        )}
        scope={RECOMMENDED_OUTFITS_HEADER}
        fireAddToBagAnalytics={fireRecommendedOutfitsAddToBagAnalytics(product)}
        fireNotifyMeClickAnalytics={enhanceNotifyMeClickAnalytics}
        handleSaveClick={handleSaveClick}
        modalControls={modalControls}
      />
    </div>
  );
}

RecommendedOutfitsProduct.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
    isDiscontinued: PropTypes.bool.isRequired,
    isInStock: PropTypes.bool.isRequired,
    shouldShowSave: PropTypes.bool.isRequired,
    images: PropTypes.arrayOf({
      isPrimary: PropTypes.bool.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    price: PropTypes.shape({
      current: PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.number,
      }).isRequired,
      previous: PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.number,
      }),
      rrp: PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.number,
      }),
      isMarkedDown: PropTypes.bool,
      isOutletPrice: PropTypes.bool,
      startDateTime: PropTypes.string,
    }).isRequired,
    id: PropTypes.number.isRequired,
    variants: PropTypes.arrayOf(PropTypes.object),
    isHeroProduct: PropTypes.bool,
    pdpUrl: PropTypes.string,
  }).isRequired,
  modalControls: PropTypes.shape({
    closeModal: PropTypes.func.isRequired,
    setFocusOnCloseElement: PropTypes.func.isRequired,
  }),
};
